import Pods from 'app/interface/redux/types/data/generic/pods'

const Default: Pods = {
  data: [],
  loading: true,
  timestamp: +new Date(),
}

export default Default
